import { appAssetUrl } from "./staticAssets";
import "../styles/adContainers.css";

const STYLE_CACHE_VERSION =
  process.env.REACT_APP_STYLE_CACHE_VERSION ||
  process.env.REACT_APP_BUILD_VERSION ||
  "1";

/** Stylesheets served from CDN (formerly under src/assets/css). */
const APP_STYLESHEETS = [
  "header.css",
  "navigation.css",
  "PersonalProfile.css",
  "newsFeed.css",
  "toggle.css",
  "AboutUs.css",
  "Articles.css",
  "Business.css",
  // "Blogs.css",
  "connection.css",
  "Editors.css",
  "HelpCenter.css",
  "History.css",
  "JobNotification.css",
  "JobSearch.css",
  "ManageResume.css",
  "notification.css",
  "people.css",
  "Post.css",
  "PrivacyPolicy.css",
  "ResumeDesign.css",
  "setting.css",
  "SignIn.css",
  "userAuth.css",
  "ViewResume.css",
];

const loadedStylesheets = new Set();

export const loadAppStylesheet = (fileName) => {
  const normalized = String(fileName || "").replace(/^css\//, "");
  const href = `${appAssetUrl(`css/${normalized}`)}?v=${encodeURIComponent(
    STYLE_CACHE_VERSION,
  )}`;

  if (loadedStylesheets.has(href)) return href;

  loadedStylesheets.add(href);
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.setAttribute("data-wlj-cdn-style", normalized);
  // Load layout-critical styles before paint when possible
  if (
    normalized === "header.css" ||
    normalized === "navigation.css" ||
    normalized === "PersonalProfile.css"
  ) {
    link.setAttribute("data-priority", "high");
  }
  document.head.appendChild(link);

  return href;
};

const injectAdThemeOverrides = () => {
  if (document.getElementById("wlj-ad-theme-overrides")) {
    return;
  }

  const style = document.createElement("style");
  style.id = "wlj-ad-theme-overrides";
  style.textContent = `
    html[data-theme="dark"] .advertiseImage,
    html[data-theme="dark"] .advertisementview,
    html[data-theme="dark"] .advertisementContainer,
    html[data-theme="dark"] .ad-container,
    html[data-theme="dark"] .Adwrapper,
    html[data-theme="dark"] .AdwrapperwithText,
    html[data-theme="dark"] .ad-wrapper,
    body.darkMode .advertiseImage,
    body.darkMode .advertisementview,
    body.darkMode .advertisementContainer,
    body.darkMode .ad-container,
    body.darkMode .Adwrapper,
    body.darkMode .AdwrapperwithText,
    body.darkMode .ad-wrapper {
      background-color: var(--ad-container-bg, #1c1c24) !important;
      border-color: var(--ad-container-border, #3c3b3d) !important;
    }

    html[data-theme="dark"] ins.adsbygoogle:not([data-adsbygoogle-status="done"]),
    body.darkMode ins.adsbygoogle:not([data-adsbygoogle-status="done"]) {
      background-color: var(--ad-container-bg, #1c1c24) !important;
    }

    html[data-theme="dark"] .adText,
    body.darkMode .adText {
      color: var(--text-color, #b5b5be) !important;
    }
  `;
  document.head.appendChild(style);
};

APP_STYLESHEETS.forEach(loadAppStylesheet);
injectAdThemeOverrides();
